import styled, { css } from 'styled-components';
import Image from '@tcp/core/src/components/common/atoms/Image';

const styles = css`
  .outfit-carousel {
    width: 100%;

    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }

  .outfit-carousel > .slick-slider > .slick-list > .slick-track {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .outfit-carousel > .slick-slider > .slick-list > .slick-track:first-child {
    padding: 0 !important;
  }

  .outfit-carousel > .slick-slider > .slick-list > .slick-track > .slick-slide {
    line-height: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .outfit-carousel > .slick-slider > .slick-list:has(.slick-track > :last-child.slick-current) {
    padding: 0px 0px 0px 60px !important;
  }

  .outfit-carousel
    > .slick-slider
    > .slick-list:has(.slick-track > .slick-current[data-index='0']) {
    padding: 0px 30px !important;
  }

  .outfit-carousel > .slick-slider > .slick-list > .slick-track > .slick-slide div {
    height: 100%;
  }
  .outfit-carousel > .slick-slider > .slick-list > .slick-track > .slick-active.slick-current {
    height: 100%;
  }

  .outfit-carousel .slick-current img {
    border: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
    min-height: 270px;
    min-width: 270px;
  }
`;

export const StyledOutfitCarousel = styled.div`
  box-sizing: border-box;
  width: 100%;
  position: relative;
  border: 1px solid #9b9b9b;
  border-radius: 6px;
  display: block;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    display: none;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    width: 390px;
    min-height: 390px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    min-width: 660px;
    max-width: 740px;
    min-height: 660px;
  }
`;

export const StyledPrevArrow = styled.span`
  border: solid ${(props) => props.theme.colors.BLACK};
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 5px;
  transform: rotate(135deg);
`;

export const CarouselButton = styled.button`
  width: 40px;
  height: 40px;
  border: 1px solid #d8d8d8;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  position: absolute;
  ${(props) => (props.right ? 'padding-left: 0' : 'padding-right: 0')};
  ${(props) => (props.left ? 'left: 16px' : 'right: 16px')};
  top: 50%;
  cursor: pointer;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    display: none;
  }
`;

export const StyledNextArrow = styled.span`
  border: solid ${(props) => props.theme.colors.BLACK};
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 5px;
  transform: rotate(315deg);
`;

export const StyledCarouselPaginatorContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  margin: 24px 0;
  @media ${(props) => props.theme.mediaQuery.large} {
    margin: 32px 0;
    justify-content: center;
  }
`;

export const StyledCarouselPaginator = styled.div`
  width: 40px;
  height: 2px;
  background: #b0b0b0;

  &.active {
    background: ${(props) => props.theme.colors.BLACK};
  }
`;

export const StyledOutfitCarouselWrapperMobile = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow-x: scroll;
  gap: 10px;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  min-width: 306px;
  min-height: 306px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    display: none;
  }
`;

export const StyledOutfitCarouselImageWrapper = styled.li`
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  flex: 0 0 306px;
  z-index: 2;
  scroll-snap-align: center;
`;

export const StyledOutfitImage = styled(Image)`
  border-radius: 6px;
  display: block;
  margin: auto;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    border: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    height: 100%;
    box-sizing: border-box;
  }
`;

export default styles;
